import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'productionItemProposal';

const productionItemProposalService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  upsert: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default productionItemProposalService;
